module.exports = __webpack_public_path__ + "static/media/loader.057aca40.svg";